import createRouter from './create-router'
import globalHooks from './global-hooks'

export {
  createRouter,
  globalHooks,
}
